import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { loadConfig } from './service/config';
import { loadUiStrings } from './service/uiStrings';
import { loadDefinitions } from './service/definitions';
// const container = document.getElementById('app');
// const root = createRoot(container);

// Load runtime configuration, UI strings and content definitions before
// mounting the app so that synchronous accessors inside components return
// populated values.
Promise.all([loadConfig(), loadUiStrings(), loadDefinitions()]).then(() => {
  ReactDOM.render(
    // root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
